module.exports = __webpack_public_path__ + "static/media/bright-white.f7b16ebd.jpg";